import {
  getCardNumberFromAddress as getCardNumberFromAddressApi,
  getTerminalsApi,
  lookupTerminalApi,
  PosByTreasury,
} from "utils/AxiosUtil";
import { NetworkType } from "utils/network";

// Merchant info, balance and transactions are fetched directly by the react-query
// hooks in features/merchant. The loadMerchantData / fetchMerchantData /
// refreshMerchantData wrappers that used to live here had no callers left (and
// carried a hardcoded fallback merchant address), so they were removed rather
// than given a network parameter they'd never receive.
async function getCardNumberFromAddress(address: string, network: NetworkType) {
  try {
    const res = await getCardNumberFromAddressApi(address, network);
    return res.data;
  } catch (error) {
    console.log(`getCardNumberFromAddress error: `, error);
    throw error;
  }
}

async function getTerminals(
  merchantId: string,
  network: NetworkType,
): Promise<PosByTreasury[]> {
  const res = await getTerminalsApi(merchantId, network);
  return res.data;
}

async function lookupTerminal(
  merchantId: string,
  serial: string,
  network: NetworkType,
) {
  const res = await lookupTerminalApi(merchantId, serial, network);
  return res.data;
}

const merchant_services = {
  getCardNumberFromAddress,
  getTerminals,
  lookupTerminal,
};
export default merchant_services;
